function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 47,
  cy: 46,
  rx: 45,
  ry: 45,
  fill: "#E7F2F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.125 28.5H29.875C27.9853 28.5 26.1731 29.2507 24.8369 30.5869C23.5007 31.9231 22.75 33.7353 22.75 35.625V59.375C22.75 61.2647 23.5007 63.0769 24.8369 64.4131C26.1731 65.7493 27.9853 66.5 29.875 66.5H63.125C65.0147 66.5 66.8269 65.7493 68.1631 64.4131C69.4993 63.0769 70.25 61.2647 70.25 59.375V35.625C70.25 33.7353 69.4993 31.9231 68.1631 30.5869C66.8269 29.2507 65.0147 28.5 63.125 28.5ZM61.5337 33.25L46.5 44.5312L31.4663 33.25H61.5337ZM63.125 61.75H29.875C29.2451 61.75 28.641 61.4998 28.1956 61.0544C27.7502 60.609 27.5 60.0049 27.5 59.375V36.2187L45.075 49.4C45.4861 49.7083 45.9861 49.875 46.5 49.875C47.0139 49.875 47.5139 49.7083 47.925 49.4L65.5 36.2187V59.375C65.5 60.0049 65.2498 60.609 64.8044 61.0544C64.359 61.4998 63.7549 61.75 63.125 61.75Z",
  fill: "#117A9B"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 98,
  height: 98,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.813646 0 0 0 0 0.887766 0 0 0 0 0.891667 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

const SvgMailBadge = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 98,
  height: 98,
  viewBox: "0 0 98 98",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMailBadge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mail-badge.07b593a9.svg";
export { ForwardRef as ReactComponent };